import { Breakpoint, useTheme } from "@mui/material";
import { useEffect, useMemo, useState } from "react";

const useMediaQueryStops = () => {
	const theme = useTheme();


	// Store the current breakpoint
	const [currentBreakpoint, setCurrentBreakpoint] = useState<Breakpoint | null>(null);

	useEffect(() => {
		const breakpoints = theme.breakpoints.values;

		// Function to determine the current breakpoint
		const getBreakpoint = () => {
			const width = window.innerWidth;
			if (width < breakpoints.sm) return "xs";
			if (width < breakpoints.md) return "sm";
			if (width < breakpoints.lg) return "md";
			if (width < breakpoints.xl) return "lg";
			return "xl";
		};

		const updateBreakpoint = () => {
			const newBreakpoint = getBreakpoint();
			if (newBreakpoint !== currentBreakpoint) {
				setCurrentBreakpoint(newBreakpoint);
			}
		};

		// Set the initial breakpoint
		updateBreakpoint();

		// Add event listener for window resize
		window.addEventListener("resize", updateBreakpoint);

		// Cleanup the event listener
		return () => {
			window.removeEventListener("resize", updateBreakpoint);
		};
	}, [theme.breakpoints.values, currentBreakpoint]);

	const stops = useMemo(() => ({
		isXs: currentBreakpoint === "xs",
		isSm: currentBreakpoint === "sm",
		isMd: currentBreakpoint === "md",
		isLg: currentBreakpoint === "lg",
		isXl: currentBreakpoint === "xl"
	}), [currentBreakpoint]);

	return stops;
};

export default useMediaQueryStops;